import {
  type UseToggleRefinementProps,
  useToggleRefinement,
} from "react-instantsearch";

import { Switch } from "@/shared-web.ui/ui.switch";
import { Text } from "@/shared-web.ui/ui.text";

interface ToggleSwitchProps extends UseToggleRefinementProps {}
const ToggleSwitch = (props: ToggleSwitchProps) => {
  const {
    value,
    refine,
  } = useToggleRefinement(props);

  const onChange = (checked: boolean) => {
    refine({ isRefined: !checked });
  };

  return (
    <div className="flex flex-row gap-2">
      <Switch
        value={value.isRefined}
        onChange={onChange}
      />
      <Text size="2">Grind</Text>
    </div>
  );
};

export { ToggleSwitch };
